module.exports = __webpack_public_path__ + "img/code_wx1.873f258d.png";